const initialState = {
  selectedUsers: [],
  role: "NONE",
  allowCreateDashboard: true,
  allowAccessToDashboardList: true,
  allowAssociateDashboards: true,
  allowAccessToCollaboratorList: true,
  allowUpdateSlide: true,
  allowCreateSlide: true,
  allowAccessToSlideList: true,
  allowUpdateDashboard: true,
  allowAccessToSettings: true,
  filter: {
    role: "ALL",
    searchWord: ""
  }
};

export const authorizationsSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INIT_USERS_SETTINGS": {
      return initialState;
    }
    case "SET_SELECTED_USERS": {
      return { ...state, selectedUsers: action.selectedUsers };
    }
    case "SET_ROLE": {
      return { ...state, role: action.role };
    }
    case "SELECT_ROLE": {
      return { ...state, filter: { ...state.filter, role: action.role } };
    }
    case "SELECT_SEARCH_WORD": {
      return {
        ...state,
        filter: { ...state.filter, searchWord: action.searchWord }
      };
    }
    case "SET_ALLOW_CREATE_DASHBOARD": {
      return { ...state, allowCreateDashboard: action.allowCreateDashboard };
    }
    case "SET_ALLOW_ACCESS_DASHBOARD_LIST": {
      return {
        ...state,
        allowAccessToDashboardList: action.allowAccessToDashboardList
      };
    }
    case "SET_ALLOW_ASSOCIATE_DASHBOARD": {
      return {
        ...state,
        allowAssociateDashboards: action.allowAssociateDashboards
      };
    }
    case "SET_ALLOW_ACCESS_COLLABORATOR_LIST": {
      return {
        ...state,
        allowAccessToCollaboratorList: action.allowAccessToCollaboratorList
      };
    }
    case "SET_ALLOW_UPDATE_SLIDE": {
      return {
        ...state,
        allowUpdateSlide: action.allowUpdateSlide
      };
    }
    case "SET_ALLOW_UPDATE_DASHBOARD": {
      return {
        ...state,
        allowUpdateDashboard: action.allowUpdateDashboard
      };
    }
    case "SET_ALLOW_CREATE_SLIDE": {
      return {
        ...state,
        allowCreateSlide: action.allowCreateSlide
      };
    }
    case "SET_ALLOW_ACCESS_SLIDE_LIST": {
      return {
        ...state,
        allowAccessToSlideList: action.allowAccessToSlideList
      };
    }
    case "SET_ALLOW_ACCESS_SETTINGS": {
      return {
        ...state,
        allowAccessToSettings: action.allowAccessToSettings
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/authorizations-settings.js